import html from '../legacy/ml.html?raw';
import { LegacyHtmlPage } from './LegacyHtmlPage';

export function MachineLearning() {
  return <LegacyHtmlPage slug="ml" title="Machine Learning & Deep Learning" html={html} />;
}
